const container = document.querySelector(".pdp_purchase__select_container");

// FOR A/B TEST
//
const control = document.querySelector(".pdp_purchase__container");
const params = new URLSearchParams(window.location.search);
const variantParam = params.get("variant");
if (variantParam === "true") {
  control.style.display = "none";
  container.style.display = "flex";
}
//
//

const dataElements = {
  otPrice: container.querySelectorAll("#otPrice"),
  otPriceSlash: container.querySelectorAll("#otPriceSlash"),
  otEntryCount: container.querySelectorAll("#otEntryCount"),
  otAppDuration: container.querySelectorAll("#otAppDuration"),
  memPrice: container.querySelectorAll("#memPrice"),
  memEntryCount: container.querySelectorAll("#memEntryCount"),
  memGiftCardAmount: container.querySelectorAll("#memGiftCardAmount"),
  swiperEntryCount: container.querySelectorAll(".swiperEntryCount"),
  // memHasAnnualGift: container.querySelector("#memHasAnnualGift"),
};

const updateDataElements = (data) => {
  Object.keys(dataElements).forEach((key) => {
    dataElements[key].forEach((elm) => (elm.innerHTML = data[key]));
  });
};

// Swiper
const swiperElm = document.querySelector(
  ".pdp_purchase__container--select .swiper-container",
);
const centerSlideIndex = parseInt(
  container.querySelector(".swiper-data").dataset.centerSlideIndex,
);
const swiperParams = {
  effect: "cards",
  grabCursor: true,
  initialSlide: centerSlideIndex,
  cardsEffect: {
    perSlideOffset: 18,
    perSlideRotate: 4,
  },
};
const pdpSwiper = new Swiper(swiperElm, swiperParams);

const toggleSwiper = (value) => {
  if (value === "membership") {
    swiperElm.classList.remove("disabled");
    pdpSwiper.enable();
  } else {
    pdpSwiper.slideTo(centerSlideIndex);
    swiperElm.classList.add("disabled");
    pdpSwiper.disable();
  }
};

let selectedOption = {
  element: null,
  data: {},
};

const selectOption = (option) => {
  if (!option) return;

  if (selectedOption.element && option.id === selectedOption.element.id) {
    return;
  }

  if (selectedOption.element) {
    selectedOption.element.classList.remove("selected");
  }

  option.classList.add("selected");
  selectedOption.element = option;
  selectedOption.data = {
    otID: option.dataset.otId,
    otPrice: option.dataset.otPrice,
    otPriceSlash: option.dataset.otPrice,
    otEntryCount: option.dataset.entryCount,
    otAppDuration: option.dataset.otAppDuration,
    memId: option.dataset.memId,
    memPrice: option.dataset.memPrice,
    memEntryCount: option.dataset.entryCount,
    memSellingPlan: option.dataset.memSellingPlan,
    memHasAnnualGift: option.dataset.memHasAnnualGift,
    memGiftCardAmount: option.dataset.memGiftCardAmount,
    swiperEntryCount: option.dataset.entryCount,
  };
  updateDataElements(selectedOption.data);
};

const purchaseOptions = container.querySelectorAll("button.option");
purchaseOptions.forEach((option) => {
  if (option.dataset.preSelected === "true") {
    selectOption(option);
  }
  option.addEventListener("click", (e) => {
    e.preventDefault();
    selectOption(option);
  });
});

let selectedRadio = {
  element: null,
  data: {},
};

const selectRadio = (option) => {
  if (!option) return;

  if (selectedRadio.element && option.id === selectedRadio.element.id) {
    return;
  }

  if (selectedRadio.element) {
    selectedRadio.element.classList.remove("selected");
    selectedRadio.element.querySelector("input").checked = false;
  }

  option.classList.add("selected");
  option.querySelector("input").checked = true;
  selectedRadio.element = option;
  selectedRadio.data = {
    value: option.dataset.value,
  };
};

const radioOptions = container.querySelectorAll(".radio");
radioOptions.forEach((option) => {
  if (option.dataset.preSelected === "true") {
    selectRadio(option);
  }
  option.addEventListener("click", (e) => {
    e.preventDefault();
    selectRadio(option);
    toggleSwiper(option.dataset.value);
  });
});

const checkoutButtons = container.querySelectorAll("button.purchase");
checkoutButtons.forEach((option) => {
  option.addEventListener("click", (e) => {
    e.preventDefault();
    const isMembership = selectedRadio.data.value === "membership";
    const variant = isMembership
      ? selectedOption.data.memId
      : selectedOption.data.otID;
    const cartParams = isMembership
      ? `items[][id]=${variant}&items[][quantity]=1&items[][selling_plan]=${selectedOption.data.memSellingPlan}`
      : `items[][id]=${variant}&items[][quantity]=1`;

    if (option.id === "addToCart") {
      console.log(`https://onecountry.com/cart/add?${cartParams}`);
      window.location.href = `https://onecountry.com/cart/add?${cartParams}`;
    } else if (option.id === "checkout") {
      console.log(
        `https://onecountry.com/cart/add?${cartParams}&return_to=/checkout`,
      );
      window.location.href = `https://onecountry.com/cart/add?${cartParams}&return_to=/checkout`;
    }
  });
});
